export default{
  "Mute Video": "वीडियो म्यूट करें",
  "HitPaw Online Mute Video": "HitPaw ऑनलाइन वीडियो म्यूट करें",
  "Fast and easy to remove sound from your video online": "अपने वीडियो से ऑनलाइन तेज़ी और आसानी से साउंड हटाएं",
  "Muting": "म्यूट किया जा रहा है",
  "Mute Failed": "म्यूट नहीं हो पाया",
  "Mute New": "नया म्यूट करें"
};